import { render, staticRenderFns } from "./add-organ.vue?vue&type=template&id=6dd17743&scoped=true"
import script from "./add-organ.vue?vue&type=script&lang=ts"
export * from "./add-organ.vue?vue&type=script&lang=ts"
import style0 from "./add-organ.vue?vue&type=style&index=0&id=6dd17743&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd17743",
  null
  
)

export default component.exports